module.exports = ".card-header{\r\n    background-color: #dcd7d7;    \r\n}\r\n.card a{\r\n    color: black;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Godown/godown-reports/godown-reports.component.css
// module id = ./src/app/Godown/godown-reports/godown-reports.component.css
// module chunks = main